import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Params, RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {SINOTTICO_STATI_ORDINATI, SINOTTICO_STATO_LABEL, SinotticoStato} from '../../sinottico/_models/SinotticoStato';
import {FILTRO_VUOTO} from '../../sinottico/_models/SinotticoFiltro';
import {queryStringDaFiltro} from '../../sinottico/_services/sinottico-filtro.helper';

export interface SegmentoStato {
  stato: SinotticoStato;
  etichetta: string;
  conteggio: number;
  percentuale: number;
  classe: string;
  queryParams: Params;
}

/** Colori dei segmenti: i bordi delle tessere del Sinottico (`CLASSI_STATO`). */
const CLASSE_SEGMENTO: Record<SinotticoStato, string> = {
  [SinotticoStato.Allarme]: 'bg-red-400',
  [SinotticoStato.InLavorazione]: 'bg-green-400',
  [SinotticoStato.InPausa]: 'bg-yellow-400',
  [SinotticoStato.Sospeso]: 'bg-orange-400',
  [SinotticoStato.Terminato]: 'bg-sky-400',
  [SinotticoStato.Ferma]: 'bg-stone-300',
};

/** Feature 161 (B1): quante risorse per stato, con link al Sinottico filtrato su quello stato. */
@Component({
  selector: 'app-dashboard-stato-macchine',
  templateUrl: './dashboard-stato-macchine.component.html',
  styleUrls: ['../dashboard-widget.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, IonicModule]
})
export class DashboardStatoMacchineComponent {
  /** null senza errore = caricamento. */
  @Input()
  set contatori(contatori: Record<SinotticoStato, number> | null) {
    this._contatori = contatori;
    this.totale = SINOTTICO_STATI_ORDINATI.reduce((t, s) => t + (contatori?.[s] ?? 0), 0);
    this.segmenti = segmentiDi(contatori, this.totale);
  }

  get contatori(): Record<SinotticoStato, number> | null {
    return this._contatori;
  }

  @Input() errore = false;

  // Calcolati una volta per input, non a ogni change detection: oggetti nuovi a ogni giro facevano ricreare a
  // *ngFor la legenda, e con i grafici chart.js nella stessa pagina la dashboard non si fermava più (come #3717).
  totale = 0;
  segmenti: SegmentoStato[] = [];
  private _contatori: Record<SinotticoStato, number> | null = null;
}

function segmentiDi(contatori: Record<SinotticoStato, number> | null, totale: number): SegmentoStato[] {
  return SINOTTICO_STATI_ORDINATI.map(stato => {
    const conteggio = contatori?.[stato] ?? 0;
    return {
      stato, conteggio, etichetta: SINOTTICO_STATO_LABEL[stato], classe: CLASSE_SEGMENTO[stato],
      percentuale: totale > 0 ? conteggio / totale * 100 : 0,
      queryParams: queryStringDaFiltro({...FILTRO_VUOTO, stati: [stato]})
    };
  });
}
